import * as React from 'react';
import { ArticleHeading2, ArticleParagraph1, Button, Image, LinkButton } from '@cian/ui-kit';

import * as styles from './styles.css';
import MY_HOME_LOGO from './assets/my_home_logo.svg';

interface IValuationModalComponentProps {
  onCLick: () => void;
  isDesktop: boolean;
}

export const ValuationModalComponent: React.FC<IValuationModalComponentProps> = ({ isDesktop, onCLick }) => {
  return (
    <div className={styles['modal']}>
      <Image src={MY_HOME_LOGO} width={125} height={125} />

      <div className={styles['heading']}>
        <ArticleHeading2 color="black_100">Оценка переехала в Мой дом</ArticleHeading2>
      </div>

      <ul className={styles['info']}>
        <li>
          <ArticleParagraph1 color="black_100">
            Это новый раздел для собственников: при каждом входе в оценку теперь вы сразу попадаете сюда
          </ArticleParagraph1>
        </li>

        <li>
          <ArticleParagraph1 color="black_100">
            Объекты, которые вы оценивали и все данные по ним перенесли в Мой дом
          </ArticleParagraph1>
        </li>

        <li>
          <ArticleParagraph1 color="black_100">
            Внутри — все полезные сервисы, чтобы вы могли выгодно сдать, продать и начать искать новое жильё
          </ArticleParagraph1>
        </li>
      </ul>

      <div className={styles['controls']}>
        <LinkButton fullWidth={!isDesktop} theme="fill_white_primary" size="L" href="/kalkulator-nedvizhimosti/">
          Вернуть Оценку
        </LinkButton>

        <Button fullWidth={!isDesktop} theme="fill_primary" size="L" onClick={onCLick}>
          Всё понятно
        </Button>
      </div>
    </div>
  );
};
